module.exports = "<p>\n  nav-bar works!\n</p>\n"